module.exports = __webpack_public_path__ + "img/coming-soon.da36c320.png";